<template>
  <div class="app-shell">
    <TopBar v-if="showNav" @toggle-sidebar="toggleMenu" />
    <div class="app-body">
      <NavBar v-if="showNav" :menuOpen="menuOpen" @close-menu="menuOpen = false" />
      <main class="app-main" :class="{ expanded: !menuOpen || !showNav }">
        <router-view /><ActionDialog />
      </main>
    </div>
  </div>
</template>

<script>
import ActionDialog from '@/components/pos/ActionDialog.vue';
import NavBar from '@/components/navbar/NavBar.vue';
import TopBar from '@/components/navbar/TopBar.vue';
import { mapActions } from 'vuex';

export default {
  components: { NavBar, TopBar, ActionDialog },
  data() {
    return { menuOpen: true };
  },
  computed: {
    showNav() {
      return !['login', 'register', 'pos', 'comandero', 'pos-inventory', 'pos-menu-sync', 'pos-device'].includes(this.$route.name);
    },
  },
  methods: {
    ...mapActions(['initializeApp']),
    toggleMenu() { this.menuOpen = !this.menuOpen; },
    handleResize() { this.menuOpen = window.innerWidth >= 992; },
  },
  mounted() {
    this.initializeApp();
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style lang="scss" scoped>
.app-shell { min-height: 100vh; }
.app-body { display: flex; min-height: 100vh; }
.app-main {
  width: 100%;
  min-width: 0;
  margin-left: 17rem;
  transition: margin-left .2s ease;
}
.app-main.expanded { margin-left: 0; }
@media (max-width: 991px) { .app-main { margin-left: 0; } }
</style>
